export const PRODUCTQUANTITY_SETBASEQUANTITY = "PRODUCTQUANTITY_SETBASEQUANTITY";
export const PRODUCTQUANTITY_SETBASEUNIT = "PRODUCTQUANTITY_SETBASEUNIT";
export const PRODUCTQUANTITY_SETTOTALWEIGHT = "PRODUCTQUANTITY_SETTOTALWEIGHT";
export const PRODUCTQUANTITY_SETUNIT = "PRODUCTQUANTITY_SETUNIT";

export const setBaseUnitQuantity = (baseQuantity) => (dispatch) => {  //debugger
    return dispatch(dispatchBaseUnitQuantity(baseQuantity))
}

export const setTotalWeight = (totalWeight) => (dispatch) => {  //debugger
    return dispatch(dispatchTotalWeight(totalWeight))
}

export const setUnit = (id) => (dispatch) => {
    return dispatch(dispatchSetUnit(id))
}

const dispatchBaseUnitQuantity = data => ({
    type: PRODUCTQUANTITY_SETBASEQUANTITY,
    payload: {baseUnitQuantity: data}
});

const dispatchTotalWeight = data => ({
    type: PRODUCTQUANTITY_SETTOTALWEIGHT,
    payload: {totalWeight: data}
});

const dispatchSetUnit = data => ({
    type: PRODUCTQUANTITY_SETUNIT,
    payload: {selectedUnit: data}
});